import { 
    SOCKS,
    TURTLE_CROSSING_PIN,
    MN_PIN,
    Product
} from '../products';

const fiftySixBrewingShirtRecos: Product[] = [
    SOCKS,
    TURTLE_CROSSING_PIN,
    MN_PIN,
];

export default fiftySixBrewingShirtRecos;
 